import { render, staticRenderFns } from "./Telecoglue.vue?vue&type=template&id=7beaf0b2&"
import script from "./Telecoglue.vue?vue&type=script&lang=js&"
export * from "./Telecoglue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports